<template>
  <div
    v-if="initialLoad"
    class="loyalty__module"
    data-bg-color="magic-hour-light"
  >
    <Icon icon="rewards-badge" />
    <template v-if="email && loggedInText">
      <accordion-module
        ref="accordion"
        class="loyalty__accordion accordion"
        data-color="night-sky-dark"
      >
        <div class="loyalty__accordion--folder accordion__folder">
          <div
            class="loyalty__accordion--title accordion__folder--title"
            data-title
            @click="toggleContent"
          >
            <div class="loyalty__in-wrapper">
              <p class="loyalty__in t4" v-html="loggedInText"></p>
              <p class="loyalty__subcopy p5">Do I have enough for a reward?</p>
            </div>
            <div class="chevron">
              <svg
                role="application"
                aria-label="open accordion"
                class="icon icon-caret"
                width="10"
                height="6"
                viewBox="0 0 10 6"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M.465 1.407a.665.665 0 0 1 .943-.938l2.885 2.882a1 1 0 0 0 1.414 0L8.592.469a.665.665 0 0 1 .943.938L6.425 4.56a2 2 0 0 1-2.847 0z"
                  fill="#283455"
                />
              </svg>
            </div>
          </div>
          <div
            class="accordion__folder--content p5"
            data-content
            data-char-count="65"
          >
            <div>
              <ul class="loyalty__points">
                <li>400 points = $10 off</li>
                <li>1000 points = $25 off</li>
                <li>2000 points = $50 off</li>
              </ul>
            </div>
          </div>
        </div>
      </accordion-module>
    </template>
    <template v-else-if="loggedOutText">
      <div class="loyalty__prospect" data-color="night-sky-dark">
        <p class="t4 loyalty__out" v-html="loggedOutText"></p>
        <p class="loyalty__account p5">
          <a
            href="https://www.brooklinen.com/account/register"
            data-color="night-sky-dark"
            >Sign Up</a
          >
          or
          <a
            href="https://www.brooklinen.com/account/login"
            data-color="night-sky-dark"
            >Sign In</a
          >
          today
        </p>
      </div>
    </template>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import Icon from '../Global/Icon.vue';

const currentPoints = ref(0);
const accordion = ref(null);
const initialLoad = ref(false);
const email = ref(false);
const loggedOutText = ref(false);
const loggedInText = ref(false);
const loyalty = ref({});

const getPoints = async () => {
  const loyaltyObj = loyalty.value;
  if (loyaltyObj.logged_in_text && loyaltyObj.logged_in_text !== '') {
    let newPoints = loyaltyObj.multiplier * loyalty.value.points_balance;
    const updatedText = loyaltyObj.logged_in_text.replace(
      '{{num}}',
      `<span data-color="night-sky-bright">${newPoints}</span>`
    );
    loggedInText.value = updatedText;
  } else
    loggedInText.value = `You have <span data-color="night-sky-bright">${loyalty.value.points_balance} Points</span> to redeem`;

  return (initialLoad.value = true);
};

const getCartPoints = async () => {
  const loyaltyLoggedText = loyalty.value.logged_out_text;

  if (loyaltyLoggedText && loyaltyLoggedText !== '')
    loggedOutText.value = loyalty.value.logged_out_text;
  else
    loggedOutText.value =
      'Join Brooklinen Rewards now to earn points on this purchase!';

  return (initialLoad.value = true);
};

const toggleContent = () => accordion.value?.toggleContent() ?? false;

onMounted(async () => {
  email.value = document.querySelector('[data-customer]')?.dataset.customer;
  loyalty.value = window.Brooklinen?.loyalty || {};
  if (email.value && loyalty.value.points_balance >= 0) await getPoints();
  else await getCartPoints();
});
</script>
